module.exports = __webpack_public_path__ + "img/账户明细.0083cca8.svg";